/*
 * @providesModule SKZLiveEventTemplateSet
 */

import _ from 'lodash';
import SKZLiveEventTemplate from 'SKZLiveEventTemplate';

export class TemplateSetRecord {
 event_templates:   Array<SKZLiveEventTemplate>;
 creation_enabled:  boolean;
}

export default class LiveEventTemplateSet extends TemplateSetRecord {

  constructor(keyValueSource: Object) {
    super();
    LiveEventTemplateSet._formatTemplates(keyValueSource);
    return _.create(LiveEventTemplateSet.prototype, keyValueSource);
  }

  static _formatTemplates(templateSet: Object) {
    if (templateSet && templateSet.event_templates) {

      const templates = templateSet.event_templates;
      if (templates.length > 0) {
        templateSet.event_templates = SKZLiveEventTemplate.make(templates);
      }
    }
  }
}
